import React, { Component } from "react";
import ReactGA from "react-ga";

export default class Footer extends Component {
  componentDidMount() {
    ReactGA.initialize("UA-180975065-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <div className="footer-page">
        <p className="copyright-footer">
          © 2020 - All Right Reserved By Ghalichin.com
        </p>
      </div>
    );
  }
}
